module.exports = __webpack_public_path__ + "img/Weapon_135.fc9124b3.png";